/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sample_DataInputs */

const th_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อมูลตัวอย่าง`)
};

const en_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample data`)
};

const ja_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンプルデータ`)
};

const zh_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`示例数据`)
};

const es_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de ejemplo`)
};

const pt_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados de exemplo`)
};

const id_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data contoh`)
};

const fr_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données d’exemple`)
};

const tl_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halimbawang datos`)
};

const vi_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dữ liệu mẫu`)
};

const ko_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예시 데이터`)
};

const de_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beispieldaten`)
};

const ru_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Демонстрационные данные`)
};

const tr_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Örnek veri`)
};

const it_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati di esempio`)
};

const pl_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane przykładowe`)
};

const uk_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Демонстраційні дані`)
};

const hi_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नमूना डेटा`)
};

const ar_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيانات تجريبية`)
};

const ms_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data contoh`)
};

const bn_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নমুনা তথ্য`)
};

const zh_tw2_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`範例資料`)
};

const zh_hk2_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`範例資料`)
};

const ur_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمونہ ڈیٹا`)
};

const fa_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دادهٔ نمونه`)
};

const sw_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data ya mfano`)
};

const nl_sample_data = /** @type {(inputs: Sample_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorbeeldgegevens`)
};

/**
* | output |
* | --- |
* | "Sample data" |
*
* @param {Sample_DataInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sample_data = /** @type {((inputs?: Sample_DataInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sample_DataInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sample_data(inputs)
	if (locale === "ja") return ja_sample_data(inputs)
	if (locale === "zh") return zh_sample_data(inputs)
	if (locale === "es") return es_sample_data(inputs)
	if (locale === "pt") return pt_sample_data(inputs)
	if (locale === "id") return id_sample_data(inputs)
	if (locale === "fr") return fr_sample_data(inputs)
	if (locale === "tl") return tl_sample_data(inputs)
	if (locale === "vi") return vi_sample_data(inputs)
	if (locale === "ko") return ko_sample_data(inputs)
	if (locale === "de") return de_sample_data(inputs)
	if (locale === "ru") return ru_sample_data(inputs)
	if (locale === "tr") return tr_sample_data(inputs)
	if (locale === "it") return it_sample_data(inputs)
	if (locale === "pl") return pl_sample_data(inputs)
	if (locale === "uk") return uk_sample_data(inputs)
	if (locale === "hi") return hi_sample_data(inputs)
	if (locale === "ar") return ar_sample_data(inputs)
	if (locale === "ms") return ms_sample_data(inputs)
	if (locale === "bn") return bn_sample_data(inputs)
	if (locale === "zh-TW") return zh_tw2_sample_data(inputs)
	if (locale === "zh-HK") return zh_hk2_sample_data(inputs)
	if (locale === "ur") return ur_sample_data(inputs)
	if (locale === "fa") return fa_sample_data(inputs)
	if (locale === "sw") return sw_sample_data(inputs)
	if (locale === "nl") return nl_sample_data(inputs)
	return en_sample_data(inputs)
});